"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroProgram() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="78165" id="lansarea-profitului" data-animate className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black py-20">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-30 bg-[url('https://i.postimg.cc/hGChnqmD/0b2a9cda0e9549098cee165feb9731526d6d5766-(1).jpg')] max-md:h-[500px]" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/60 to-black max-md:from-transparent max-md:via-black max-md:to-black max-md:via-[450px]" />
      </div>

      <div ref={ref} className="relative z-10 container text-left flex flex-col-reverse items-center gap-12 transition-all duration-1000 ease-out transform opacity-100 translate-y-0 w-full !bg-transparent ![padding:0px_16px_32px_16px] md:flex-row">
        <div className="flex-1 w-full">
          <h1 className="relative z-20 -mt-[115px] text-4xl md:mt-[155px] md:text-5xl lg:text-6xl font-extrabold text-primary-500 mb-4 tracking-tight leading-tight uppercase">
            <span className="text-white">POSTEZI PE SOCIAL MEDIA</span>
            <br />
            <span className="text-primary-500">DAr CLIENȚII NU APAR</span>
            <span className="text-white">?</span>
          </h1>
          
          <p className="text-lg md:text-xl text-primary-100/90 mb-5 max-w-3xl font-medium leading-relaxed">
            Curs practic de marketing pentru antreprenori care vor să atragă clienți din Instagram, TikTok și Facebook
          </p>

          <Link to="#oportunitate-bonus">
            <div className="flex justify-center">
              <Button size="lg" className="btn h-14 px-10 text-lg uppercase tracking-wider font-bold">
                Înscrie-te la curs!
              </Button>
            </div>
          </Link>
        </div>

        <div className="relative flex-1 w-full flex justify-center md:justify-end">
          <img src="https://i.postimg.cc/kXpq937k/Screenshot-2026-03-14-at-15-47-26-removebg-preview.png" alt="Background Logo" className="absolute top-[30%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-[450px] md:max-w-[750px] opacity-50 z-0 pointer-events-none" />
          <div className="relative z-10 w-full max-w-[400px] md:max-w-[500px] lg:max-w-[600px] h-[400px] md:h-auto overflow-hidden">
            <img src="https://vladcotoros.md/wp-content/uploads/2026/03/DSC06712-removebg-preview.png" alt="Alexandru Bordea" className="w-full h-full object-contain object-top drop-shadow-2xl md:object-center" />
            <div className="absolute inset-x-0 bottom-0 h-[60%] bg-gradient-to-t from-black to-transparent pointer-events-none" />
          </div>
        </div>
      </div>
    </section>;
}